import { ServiceSummary, ServiceWithClaims } from "./interfaces";

/**
 * Returns true if any one-time seat service has been added, removed,
 * or had its claims changed between originalServices and selectedServices.
 */
export function hasOneTimeSeatChanges(
  availableServices: ServiceSummary[],
  originalServices: ServiceWithClaims[],
  selectedServices: ServiceWithClaims[],
): boolean {
  const isOneTimeSeatService = (s: ServiceWithClaims) =>
    availableServices.some(
      (svc) =>
        svc.oneTimeSeats &&
        svc.serviceReference === s.serviceReference &&
        svc.licenseReference === s.licenseReference,
    );

  const originalOneTimeSeats = originalServices.filter(isOneTimeSeatService);
  const selectedOneTimeSeats = selectedServices.filter(
    (s) => isOneTimeSeatService(s) && s.claims.length > 0,
  );

  // A service containing one-time seat was added or removed
  if (originalOneTimeSeats.length !== selectedOneTimeSeats.length) return true;

  // Claims changed on an existing one-time seat service
  for (const original of originalOneTimeSeats) {
    const selected = selectedOneTimeSeats.find(
      (s) =>
        s.serviceReference === original.serviceReference &&
        s.licenseReference === original.licenseReference,
    );
    if (!selected) return true;
    if (selected.claims.length !== original.claims.length) return true;
  }

  return false;
}
